import AvatarCropperModal from './AvatarCropperModal';

export default AvatarCropperModal;
